module.exports = __webpack_public_path__ + "static/media/step_length.211fa3fc.png";